import { FinanceRate } from '@kanda-libs/ks-frontend-services';

export const INITIAL = {
  changeDeposit:
    '* Minimum monthly amounts are calculated assuming the longest duration allowed for the applicable APR.',
  fixedDeposit:
    '* Minimum monthly amounts are calculated assuming the longest duration and maximum deposit allowed for the applicable APR.',
};

export const SHOWCASE: Record<NonNullable<FinanceRate['apr_type']>, string> = {
  BUYNOW_PAYLATER:
    'Representative example of {{minimumMonthly}} per month: Based upon a loan of {{loan}}, using Buy Now, Pay Later, with an initial {{deferred}} months deferred payment, then repayable over {{duration}} months at an interest rate of {{apr}} APR representative p.a. Total amount payable {{loanCost}}',
  INTEREST_BEARING:
    'Representative example of {{minimumMonthly}} per month: Based upon a loan of {{loan}}, repayable over {{duration}} months at an interest rate of {{apr}} APR representative p.a. Total amount payable {{loanCost}}',
  INTEREST_FREE:
    'Representative example of {{minimumMonthly}} per month: Based upon a loan of {{loan}}, repayable over {{duration}} months interest free. Total amount payable {{loanCost}}',
};
